module.exports = __webpack_public_path__ + "img/cosmos_logo.2693a88e.png";